import React from "react";
import { withRouter } from "react-router-dom";
import useStore from "../../../context/useStore";
import Loader from "../../common/Loader";
import ExcelCopyModal from "../../common/ExcelCopyModal";
import AddColumnModal from "./AddColumnModal";
import AddRowModal from "./AddRowModal";
import Control from "../../common/Control";
import useMaintenanceDetail from "./useMaintenanceDetail";

const MaintenanceDetail = (props) => {
  const [state] = useStore();

  const {
    maintenanceDetailActions,
    maintenanceData,
    brandModelData,
    brandData,
    constantData,
    r_actions,
  } = useMaintenanceDetail(props);

  const {
    tableValueChange,
    inputChange,
    toggleBrandModels,
    toggleFuelTypes,
    formatExcelData,
    addColumn,
    deleteCol,
    addRow,
    deleteRow,
  } = maintenanceDetailActions;

  var tableRows = [];
  for (let key in maintenanceData.tableValues.values) {
    var row = maintenanceData.tableValues.values[key];
    var tds = [];
    row.forEach((r, k) => {
      tds.push(
        <td key={"tdr-" + key + "-" + k}>
          <input
            type="text"
            className="form-control px-1 text-center"
            name={"val"}
            onChange={(e) => tableValueChange(e, key, k)}
            value={r}
          />
        </td>
      );
    });
    tableRows.push(
      <tr key={"trr-" + key}>
        <td className="font-weight-bold">
          <button
            className="btn btn-default px-1 py-0 mr-1 btn-round"
            onClick={() => deleteRow(key)}
          >
            <i style={{ color: "red" }} className="fa fa-minus" />
          </button>
          {key} mois
        </td>
        {tds}
      </tr>
    );
  }
  tableRows.push(
    <tr key={"trmodal-666666"}>
      <td className="text-center">
        <button
          className="btn btn-secondary"
          data-toggle="modal"
          data-target="#addRowModal"
        >
          <i className="fa fa-plus" />
        </button>
      </td>
    </tr>
  );

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          <h1>Edition d'un tableau d'entretien</h1>
          <h4>{maintenanceData.name || ""}</h4>
          <div className="row">
            <div className="col-12">
              <Control
                label="Catalogue"
                type="select"
                name="catalog"
                value={maintenanceData.catalog}
                change={inputChange}
                error={state.error}
                datas={state.catalogStore.items}
                dataIndex="uuid"
                required={true}
              />
              {/* <Control
                label="Nom"
                type="text"
                name="name"
                disabled
                value={maintenanceData.name}
                change={inputChange}
                error={state.error}
              /> */}
              <Control
                label="Marque"
                type="select"
                name="brand"
                change={inputChange}
                value={maintenanceData.brand}
                disabled={
                  maintenanceData.nextPeriod || maintenanceData.previousPeriod
                    ? true
                    : false
                }
                datas={brandData}
                dataIndex="uuid"
                dataLabel="name"
                error={state.error}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-6">
                  <div className="form-group">
                    <label htmlFor="models">Modèles</label>
                    {brandModelData.map((brandModel, k) => (
                      <Control
                        key={brandModel.uuid}
                        label={brandModel.name}
                        type="checkbox"
                        name="brandModel"
                        change={toggleBrandModels}
                        checked={
                          maintenanceData.brandModels.find(
                            (bm) => bm == brandModel.uuid
                          )
                            ? true
                            : false
                        }
                        disabled={
                          maintenanceData.nextPeriod ||
                          maintenanceData.previousPeriod
                            ? true
                            : false
                        }
                        k={brandModel.uuid}
                      />
                    ))}
                    <small className="form-text text-danger">
                      {state.error.brandModels}
                    </small>
                  </div>
                </div>
                <div className="col-6">
                  <div className="form-group">
                    <label htmlFor="fuelType">Carburant</label>
                    {constantData.FUEL_TYPES.map((fuelType, k) => (
                      <Control
                        key={fuelType.id}
                        label={fuelType.name}
                        type="checkbox"
                        name="brandModel"
                        change={toggleFuelTypes}
                        checked={
                          maintenanceData.fuelTypes.find(
                            (ft) => ft == fuelType.id
                          )
                            ? true
                            : false
                        }
                        disabled={
                          maintenanceData.nextPeriod ||
                          maintenanceData.previousPeriod
                            ? true
                            : false
                        }
                        k={fuelType.id}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12">
              <h3>Tableau des valeurs</h3>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th className="text-center">Durée/Km</th>
                    {maintenanceData.tableValues.km.map((km, k) => (
                      <th className="text-center" key={"km-" + km}>
                        <button
                          className="btn btn-default px-1 py-0 mr-1 btn-round"
                          onClick={() => deleteCol(k)}
                        >
                          <i style={{ color: "red" }} className="fa fa-minus" />
                        </button>
                        {km}
                      </th>
                    ))}
                    <th className="text-center">
                      <button
                        className="btn btn-secondary"
                        data-toggle="modal"
                        data-target="#addColumnModal"
                      >
                        <i className="fa fa-plus" />
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody>{tableRows}</tbody>
              </table>
            </div>
          </div>
          <button
            type="button"
            className="btn btn-primary mr-2"
            data-toggle="modal"
            data-target="#excelCopyModal"
          >
            Copier depuis excel
          </button>
          {state.maintenance.isLoading ? (
            <Loader />
          ) : (
            <button
              type="button"
              className="btn btn-success mr-2"
              onClick={() => r_actions.saveMaintenance(maintenanceData)}
            >
              Enregistrer
            </button>
          )}
        </div>
      </div>
      <ExcelCopyModal showOptionTTC={true} formatExcelData={formatExcelData} />
      <AddColumnModal addColumn={addColumn} />
      <AddRowModal addRow={addRow} />
    </div>
  );
};

export default withRouter(MaintenanceDetail);
